

export const AdditionalTypes = {
  NOTE: 'Note',
  RATE_CALL: 'Rate Call',
  EMAIL: 'Email',
};

